<template>
  <riseup-button
    class="dd-button"
    :title="title"
    :action="action"
    :loading="loading"
    :disabled="disabled"/>
</template>

<script>
import BaseUI from 'base-ui';

export default {
  name: 'DynamicDepositButton',
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  props: {
    action: Function,
    title: String,
    loading: Boolean,
    disabled: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.dd-button {
  width: 100%;
  height: 75px;
}
</style>
